import { createSelector } from 'reselect';

const getAppVersion = createSelector(
  (state) => state.shared,
  (shared) => shared?.appVersion,
);

export default getAppVersion;
